export const wordPool = {
  title: '単語プール',
  subtitle: 'レベル別の単語とフレーズを確認',
  
  // Filters
  filterByLanguage: '言語でフィルター',
  filterByLevel: 'レベルでフィルター',
  allLanguages: 'すべての言語',
  allLevels: 'すべてのレベル',
  
  // Languages
  japanese: '日本語',
  korean: '한국어',
  english: 'English',
  
  // Levels
  levelA: 'レベルA',
  levelB: 'レベルB',
  levelC: 'レベルC',
  
  // Table Headers
  word: '単語/フレーズ',
  meaning: '意味',
  language: '言語',
  level: 'レベル',
  
  // Actions
  addWord: '単語を追加',
  search: '検索',
  searchPlaceholder: '単語を検索...',
  
  // Messages
  noWords: '単語が見つかりませんでした',
  loading: '読み込み中...'
};
